import { Button, CircularProgress } from '@mui/material';

const RunButton = ({ onClick, isLoading, isDisabled }) => {
    return (
        <Button variant="contained" onClick={onClick} disabled={isDisabled}>
            Run
            {isLoading && <CircularProgress sx={{ marginLeft: '12px' }} size="1rem" />}
        </Button>
    );
};

export default RunButton;
